import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

function getOptions(positionsMap) {
    const options = {};

    Object.keys(positionsMap).map((positionName) => {
        options[positionName] = positionName;
    });

    return options;
}

class PlayerPosition extends Component {
    constructor(props) {
        super(props);

        const player = this.getPlayer();

        this.selectablePositionsMap = player.selectablePositionsMap || {};
    }

    getPlayer() {
        const {players, playerId} = this.props;

        return players.getPlayer(playerId);
    }

    onChange(value) {
        if (!this.selectablePositionsMap.hasOwnProperty(value)) {
            return;
        }

        const {playerId} = this.props;

        this.props.dispatch(
            Action.do('changePlayersPosition', [
                {
                    playerId,
                    positionSlug: value,
                },
            ]),
        );
    }

    render() {
        const player = this.getPlayer();

        if (!player) {
            return null;
        }

        if (isEmpty(this.selectablePositionsMap)) {
            return <span className="pos-text">{player.positionName}</span>;
        }

        return (
            <SimpleSelect
                key={`${player.getId()}-${player.positionName}`}
                className="form-control pos-select"
                value={player.positionName}
                options={getOptions(this.selectablePositionsMap)}
                onChange={this.onChange.bind(this)}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {players},
    } = state;

    return {
        sportConfig,
        players,
    };
}

export default connect(mapStatesToProps)(PlayerPosition);
